import { TokenType } from 'state/types';
import { graphqlTokenVar } from 'state/vars';

export const setTokenType = (tokenType: TokenType) => {
  const current = graphqlTokenVar();
  // Skip redundant writes so the single derive-and-publish effect can run on every
  // credential change without re-notifying subscribers (which would loop renders).
  if (current.tokenType === tokenType && !current.loading) return;
  graphqlTokenVar({ ...current, loading: false, tokenType });
};

export const setLoadingTokens = () => {
  graphqlTokenVar({ ...graphqlTokenVar(), loading: true });
};

export const triggerFetchToken = () => {
  graphqlTokenVar({ ...graphqlTokenVar(), isTriggerFetchToken: true });
};

export const untriggerFetchToken = () => {
  graphqlTokenVar({ ...graphqlTokenVar(), isTriggerFetchToken: false });
};
